import { parseISO } from 'date-fns/parseISO';

import { formatDateNonlocalised } from '../../../../bootstrap/localisation';

import type { DateData } from '../../selectors/types';

// Gets lowest median price from flexible dates service
// from between checkin and checkout dates
export default function getSelectedLowestIndicativePrice(
  checkInDate: Date | null,
  checkOutDate: Date | null,
  dateData?: DateData,
) {
  if (checkInDate && checkOutDate && dateData) {
    const formattedCheckInDate = formatDateNonlocalised(checkInDate);
    const formattedCheckOutDate = formatDateNonlocalised(checkOutDate);

    if (dateData[formattedCheckInDate] && dateData[formattedCheckOutDate]) {
      const entityDateDataKeys = Object.keys(dateData).sort(
        (a, b) => parseISO(a).getTime() - parseISO(b).getTime(),
      );
      const selectedDates = entityDateDataKeys.slice(
        entityDateDataKeys.indexOf(formattedCheckInDate),
        entityDateDataKeys.indexOf(formattedCheckOutDate),
      );

      if (selectedDates.length === 0) {
        return dateData[formattedCheckInDate].medianPrice;
      }

      const selectedLowestIndicativePrice = selectedDates
        .map((singleDate) => dateData[singleDate].medianPrice)
        .sort((prev, curr) => prev - curr)[0];

      return selectedLowestIndicativePrice;
    }
  }

  return null;
}
